import DepositWithdrawalItem from './DepositWithdrawalItem';

export default DepositWithdrawalItem;
